import { ENTRY_PRICE_LABEL, AI_ACT_FROM_LABEL, DSA_PRICE_LINE, DSA_PRICE_SECOND } from '../../lib/pricing.js';

const SELF_CHECK = { label: 'Take the 3-minute check', href: '/gdpr-self-assessment/' };

// Where the rail's Startup Program card sends people. The Startup Program card
// on /pricing until the eligibility form ships; then point this at the form.
export const STARTUP_FORM_URL = '/pricing/#startup';

// CTA variants for Resources articles, chosen by front-matter `cta`. The
// right rail shows <RailCta> (keyed to the article's service; the GDPR card
// uses gdpr-signup's button and href) and <StartupCard>. The other fields
// (headline, line, railIcon, railTerms, primary, secondary, helps) are kept as
// data; nothing renders them since the "How Gabsor helps" block was removed.
// Wording stays within what the service pages already state; the price comes
// from src/lib/pricing.js.
export const RESOURCE_CTAS = {
  'gdpr-signup': {
    headline: 'Appoint your GDPR representative',
    line: `EU and UK coverage from ${ENTRY_PRICE_LABEL}.`,
    button: 'Appoint in 5 minutes',
    href: '/pricing/',
    railIcon: true,
    // Not "No lock-in": the from-price is the annual plan, prepaid and
    // non-refundable. Every plan runs to the end of its term (pricing FAQ).
    railTerms: 'Cancel at end of term',
    primary: { label: 'Appoint your representative', href: '/pricing/', note: `from ${ENTRY_PRICE_LABEL}` },
    secondary: SELF_CHECK,
    helps: [
      'Named EU and UK representative from our Irish and UK companies.',
      'Signed Letter of Appointment and Certificate of Representation, issued online.',
      'Authority and data subject correspondence received and handled by the Gabsor team.',
    ],
  },
  'startup-program': {
    headline: 'Startup Program',
    line: 'Special pricing and flexible terms for early-stage companies.',
    button: 'Ask about the Startup Program',
    href: '/contact/',
    secondary: SELF_CHECK,
    helps: [
      'Startup-friendly pricing for EU and UK GDPR representation.',
      'Flexible contract terms that scale with your growth.',
      'Fast onboarding: sign up and get your appointment online.',
      'Solo builders without a company can sign up as individuals.',
    ],
  },
  'ai-act-quote': {
    headline: 'AI Act authorised representative',
    line: `From ${AI_ACT_FROM_LABEL} for one high-risk AI system, from our entity in Ireland.`,
    button: 'How the service works',
    href: '/eu-ai-act-representative/',
    helps: [
      'Authorised representative for providers of high-risk AI systems and general-purpose AI models.',
      'Documentation kept at the disposal of EU regulators for the required period.',
      'One account for your AI Act and GDPR appointments.',
    ],
  },
  'dsa-quote': {
    headline: 'DSA legal representative',
    line: `${DSA_PRICE_LINE}: ${DSA_PRICE_SECOND}. From our entity in Ireland.`,
    button: 'Request a quote',
    href: '/contact/',
    helps: [
      'Article 13 DSA legal representative established in Ireland.',
      'We notify Coimisiún na Meán, the Irish Digital Services Coordinator.',
      'Ready-to-paste representative details for your site and terms.',
    ],
  },
  contact: {
    headline: 'Talk to our team',
    line: 'Questions about EU or UK representation? We typically reply within one business day.',
    button: 'Contact us',
    href: '/contact/',
    helps: [
      'Representation under GDPR, the DSA, the AI Act and the Data Act.',
      'Our Irish and UK companies.',
      'One account for all of your appointments.',
    ],
  },
};

export const CTA_KEYS = Object.keys(RESOURCE_CTAS);

// One-line prompts inside an article body: <InlineCta variant="assessment" />.
export const INLINE_CTAS = {
  assessment: { text: 'Not sure whether this applies to you?', link: SELF_CHECK.label, href: SELF_CHECK.href },
};

export const INLINE_CTA_KEYS = Object.keys(INLINE_CTAS);
